<template>
  <v-dialog v-model="isModalOn" max-width="500px" @click:outside="onClose" @keydown.esc="onClose">
    <v-card>
      <v-card-title>{{title}}</v-card-title>
      <slot name="content">
        <v-card-subtitle>{{subtitle}}</v-card-subtitle>
      </slot>
      <slot name="buttons">
        <v-card-actions>
          <v-btn v-if="close" @click="onClose" text color="rgb(20,200,200)"> {{close}}</v-btn>
          <v-btn v-if="ok" @click="onOk" text color="rgb(20,200,200)">{{ok}}</v-btn>
          <v-btn v-if="optionOne" @click="onOptionOne" text color="rgb(20,200,200)">{{optionOne}}</v-btn>
        </v-card-actions>
      </slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "card",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    close: {
      type: String,
      default: "",
    },
    ok: {
      type: String,
      default: "",
    },
    optionOne: {
      type: String,
      default: "",
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isModalOn: false,
    };
  },
  methods: {
    onOk() {
      this.$emit("ok");
      this.isModalOn = false;
    },
    onClose() {
      this.$emit("close");
      this.isModalOn = false;
    },
    onOptionOne() {
      this.$emit("optionOne");
      this.isModalOn = false;
    },
  },
  beforeDestory() {},
  watch: {
    showModal: {
      handler(newVal) {
        this.isModalOn = newVal;
      },
      immediate: true,
    },
  },
  isModalOn(newVal) {
    if (!newVal) {
      this.$emit("close");
    }
  },
};
</script>

<style scoped>
</style>
